export const CELL_COUNT = 6;

export const RESET_TIMER = 60;
